import { makeStyles } from "@material-ui/core";
import { backdropClasses } from "@mui/material";

export const FormConditionsStyles = makeStyles((theme) => ({
    button: {
        marginBottom: '1em',
        padding: '6px 30px'
    },
    label: {
        marginBottom: '0.5em',
        fontWeight: '550',
    },
    addConditions: {
        fontSize: 15,
        fontWeight: 'bold'
    },
    conditionsContainer: {
        padding: theme.spacing(2),
        //margin: '0 1em',
        marginTop: '1em',
        borderRadius: '5px',
        border: '1px solid #d4d7d9ff',
        background: '#E9F5FF'
    },
    expandIcon: {
        cursor: 'pointer',
        color: '#0090fe'
    },
    selectWhite: {
        backgroundColor: theme.palette.background.paper,
        cursor: 'pointer'
    },
    tooltip: {
        padding: '0.5em'
    }
}));
